// src/App.js
import './Layout.scss';
import LandingPage from './sections/landing/LandingPage.jsx';
import NftTestPage from './sections/nfttest/NftTestPage.jsx';
import BobTestPage from './sections/nfttest/BobTestPage.jsx';
import NftGenPage from './sections/nftgen/NftGenPage.jsx';
import BobDashboardPage from './sections/bobdashboard/BobDashboardPage.jsx';
import ToolsDashboardPage from './sections/toolsdashboard/ToolsDashboardPage.jsx';
import LaunchpadPage from './sections/launchpad/LaunchpadPage.jsx';

const LAUNCHPAD_ROOT_HOSTS = new Set(["gbob.fun", "www.gbob.fun"]);

export default function App() {
  const path = typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "/";
  const host = typeof window !== "undefined" ? String(window.location.hostname || "").toLowerCase() : "";
  const isLaunchpadRootHost = LAUNCHPAD_ROOT_HOSTS.has(host);

  if (isLaunchpadRootHost) return <LaunchpadPage />;
  if (path.startsWith("/nfttest")) return <NftTestPage mode="nfttest" />;
  if (path.startsWith("/bobtest")) return <BobTestPage />;
  if (path.startsWith("/nftgen")) return <NftGenPage />;
  if (path.startsWith("/dashboard")) return <BobDashboardPage />;
  if (path.startsWith("/tools")) return <ToolsDashboardPage />;
  if (path.startsWith("/launchpad")) return <LaunchpadPage />;

  return <LandingPage />;
}
